'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function OfferExclusive({ className }) {
  return h(`.${className}`, [
    h(`span.${className}-icon.icon-logo-g`),
    h(
      Translate,
      { attrs: { class: `${className}-text` } },
      'js.modules.shared.Exclusive'
    ),
  ]);
}

module.exports = OfferExclusive;
